import React from 'react'

import cx from 'classnames'
import Image, { StaticImageData } from 'next/image'

import { SupercellSLogo } from '@/components/Icons'

import styles from './HeroContent.module.scss'

type HeroSlideProps = {
  title: string
  description: string | JSX.Element
  image: StaticImageData
  imagePosition?: string
  imagePriority?: boolean
  gameLogo?: StaticImageData
  gameLogoClassName?: string
}

export const HeroContent: React.FC<HeroSlideProps> = ({
  children,
  image,
  imagePosition,
  imagePriority,
  title,
  description,
  gameLogo,
  gameLogoClassName,
}) => {
  const sizes = '(max-width: 1384px) 100vw, 2768w'

  return (
    <>
      <div className={styles.ImageContainer}>
        <Image
          src={image}
          alt={title}
          layout="fill"
          placeholder="blur"
          objectFit="cover"
          objectPosition={imagePosition}
          sizes={sizes}
          quality="100"
          priority={imagePriority}
          className={styles.HeroImage}
        />
        <div className={styles.OverlayBackground} />
        <div className={styles.OverlayStripe} />
        {gameLogo && (
          <div className={cx(styles.GameLogo, gameLogoClassName)}>
            <Image src={gameLogo} objectFit="contain" alt="gamelogo" />
          </div>
        )}
      </div>
      <div className={styles.Content}>
        <div className={styles.Overlay}>
          <SupercellSLogo />
          <h1 className={styles.OverlayTitle}>{title}</h1>
          <h2 className={styles.OverlayDescription}>{description}</h2>
          <div className={styles.OverlayActionContainer}>{children}</div>
        </div>
      </div>
    </>
  )
}
